import { render, staticRenderFns } from "./CTextarea.vue?vue&type=template&id=1ebc028e&"
import script from "./CTextarea.vue?vue&type=script&lang=js&"
export * from "./CTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports